"use client";

import { useTranslations } from "next-intl";

import * as track from "../tracking/catalogPage.tracking";
import type { CatalogMetaResponse, CatalogSort } from "../types/catalog.type";
import { useCatalogSettings } from "./useCatalogSettings.hook";

type Sorting = CatalogMetaResponse["header"]["sorting"];

export function useSortControl(sorting: Sorting) {
  const t = useTranslations("catalog");
  const [settings, setSettings] = useCatalogSettings();

  const isNonDefaultSort = settings.sort !== sorting[0]?.value;

  const selectedLabel =
    sorting.find((item) => item.value === settings.sort)?.label ??
    t("sort.sort");

  const applySort = (value: string) => {
    setSettings({ sort: value as CatalogSort, page: 1 });

    const selectedSort = sorting.find((item) => item.value === value);
    if (selectedSort) {
      track.catalogSortClick(selectedSort.tracking_value);
    }
  };

  return {
    currentSort: settings.sort,
    isNonDefaultSort,
    selectedLabel,
    applySort,
  };
}
